export const getImageUrlWithBucketPrefix = (imageUrl: string) => {
  const bucketPrefix = import.meta.env.VITE_S3_BUCKET_PREFIX;

  if (imageUrl && imageUrl.indexOf('https://') === -1) {
    return `${bucketPrefix}${imageUrl}`;
  }
  return imageUrl;
};
